import type { ComputedRef } from 'vue';
import { computed } from 'vue';

import type { IContextQueryResult } from '@modules/core/services/query/types';
import { useRestClient } from '@modules/core/services/api';
import { useContextQuery } from '@modules/core/services/query';
import { GROUPS_OF_ADMINS_PERMISSIONS } from '@modules/groups-of-admins/constants';
import { AVAILABLE_ADMINS_LIST_QUERY_API_URL, AVAILABLE_ADMINS_LIST_QUERY_KEY } from '@modules/groups-of-admins/submodules/edit/constants';

import type { IGroupMembersResponse } from '../types';

export default function useAvailableAdminsListQuery(id: ComputedRef<number | undefined>): IContextQueryResult<IGroupMembersResponse, Error> {
  const { fetchGet } = useRestClient();

  return useContextQuery<IGroupMembersResponse, Error>({
    queryKey: [AVAILABLE_ADMINS_LIST_QUERY_KEY, id],
    queryFn: ({ signal }) => fetchGet<IGroupMembersResponse>(AVAILABLE_ADMINS_LIST_QUERY_API_URL, {
      signal,
      permission: GROUPS_OF_ADMINS_PERMISSIONS.EDIT,
      urlParams: {
        id: id.value,
      },
    }),
    enabled: computed(() => !!id.value),
  });
}
